<template>
  <div>
    <Button
      :size="15"
      color="#dc3545"
      colorText="#ffffff"
      tooltip="Importar"
      icon="fas fa-file-import"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" title="Importar módulo"> Importar Módulos </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";

// Buttom
import Button from "../../../common/Button";

export default {
  components: {
    UiModal,
    Button,
  },
  methods: {
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
};
</script>

<style></style>
